import http from '@/http'
import { normalizePersonalAccount } from '@/utils/normalizeResult'

const SET_RESULTS = 'SET_RESULTS'
const SET_LOADING = 'SET_LOADING'
const SET_ALERT = 'SET_ALERT'

export const state = {
  results: {},
  loading: false,
  alert: null
}

export const mutations = {
  [SET_RESULTS] (state, payload) {
    state.results = normalizePersonalAccount(payload)
  },
  [SET_LOADING] (state) {
    state.loading = !state.loading
  },
  [SET_ALERT] (state, alert) {
    state.alert = alert
  }
}

export const actions = {
  getPersonalAccount ({ commit, rootState }) {
    commit(SET_LOADING)
    commit(SET_ALERT, '')

    const userId = (rootState.auth.user) ? `?id=${rootState.auth.user.id}` : ''
    return http.get(`/api/user/${userId}`).then(response => {
      if (response.status === 200) {
        commit(SET_RESULTS, response.data)
      }
      commit(SET_LOADING)
    }).catch(() => {
      /* TODO HANDLE ERROR */
      commit(SET_LOADING)
    })
  },

  postPersonalAccount ({ commit }, data) {
    commit(SET_LOADING)

    return http.post('/api/user/update/', data).then(response => {
      if (response.status === 200) {
        commit(SET_ALERT, 'Cadastro pessoal atualizado com sucesso')

        // UPDATE AUTH USER | Currently lost company context
        // commit('auth/SET_AUTH', response.data.user, { root: true })
      }
      if (response.status === 403) {
        commit(SET_ALERT, 'A atualização falhou.')
      }
      commit(SET_LOADING)
      return Promise.resolve(response)
    }).catch(error => {
      commit(SET_LOADING)
      commit(SET_ALERT, error.response.data.message)
      return Promise.reject(error)
    })
  }
}

export default {
  namespaced : true,
  state,
  mutations,
  actions
  /* getters */
}
